// Material UI
import { makeStyles } from '@material-ui/core';
// Constants
import Colors from '../../constants/Colors';

export default makeStyles(theme => ({
  root: {
    alignSelf: 'center',
  },
  submitButton: {
    color: Colors.PRIMARY_COLOR,
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: '16px',
    background: 'transparent',
  },
}));
